import * as React from "react";

import CategoryTypeCard from "../../../components/CategoryTypeCard";
import * as CustomLists from "../../../models/customLists";

var Row = require("react-flexbox-grid").Row;

export interface CategoryTypeSelectorProps extends React.Props<any> {
    onCategoryTypeSelectedCallback: (type: CustomLists.CategoryType) => void;
}

export class CategoryTypeSelector extends React.Component<CategoryTypeSelectorProps> {
    render() {
        return (
            <div style={{ margin: 20 }}>
                <Row>
                    <CategoryTypeCard
                        categoryType={CustomLists.CategoryType.Vocabulary}
                        onSelectedCallback={this.props.onCategoryTypeSelectedCallback}
                    />
                </Row>
                <Row>
                    <CategoryTypeCard
                        categoryType={CustomLists.CategoryType.VocabularyTextOnly}
                        onSelectedCallback={this.props.onCategoryTypeSelectedCallback}
                    />
                </Row>
                <Row>
                    <CategoryTypeCard
                        categoryType={CustomLists.CategoryType.Expression}
                        onSelectedCallback={this.props.onCategoryTypeSelectedCallback}
                    />
                </Row>
                <Row>
                    <CategoryTypeCard
                        categoryType={CustomLists.CategoryType.ExpressionTextOnly}
                        onSelectedCallback={this.props.onCategoryTypeSelectedCallback}
                    />
                </Row>
                <Row>
                    <CategoryTypeCard
                        categoryType={CustomLists.CategoryType.Lesson}
                        onSelectedCallback={this.props.onCategoryTypeSelectedCallback}
                    />
                </Row>
            </div>
        );
    }
}
